import { PROFILE_FIELDS } from '../../../constants/strings';
import { LENGTH_VALUES } from '../../../constants/validations';
import { getPhoneWithoutUSCode } from '../../../utils/getPhone';
import { RULES } from '../../../utils/validations';
import { IDS } from '../../../constants/ids';

export function getFieldsHomeAddressSection(formatMessage, profile) {
  return [
    {
      id: IDS.FORM_FIELDS.ADDRESS_1,
      name: formatMessage(PROFILE_FIELDS.fieldNames.address1),
      value: profile.address1,
      fieldName: 'address1',
      limit: LENGTH_VALUES.ADDRESS_1.MAX,
    },
    {
      id: IDS.FORM_FIELDS.ADDRESS_2,
      name: formatMessage(PROFILE_FIELDS.fieldNames.address2),
      value: profile.address2,
      fieldName: 'address2',
      limit: LENGTH_VALUES.ADDRESS_2.MAX,
    },
    {
      id: IDS.FORM_FIELDS.CITY,
      name: formatMessage(PROFILE_FIELDS.fieldNames.city),
      value: profile.city,
      fieldName: 'city',
      limit: LENGTH_VALUES.CITY.MAX,
    },
    {
      id: IDS.FORM_FIELDS.STATE,
      name: formatMessage(PROFILE_FIELDS.fieldNames.state),
      value: profile.state,
      fieldName: 'state',
      type: 'select',
      limit: LENGTH_VALUES.STATE.MAX,
    },
    {
      id: IDS.FORM_FIELDS.POSTAL_CODE,
      name: formatMessage(PROFILE_FIELDS.fieldNames.postalCode),
      validationRules: {
        [RULES.POSTAL_CODE]: {
          message: 'profile.postalCode.format',
        },
      },
      value: profile.postalCode,
      fieldName: 'postalCode',
      limit: LENGTH_VALUES.POSTAL_CODE.MAX,
    },
    {
      id: IDS.FORM_FIELDS.COUNTRY,
      name: formatMessage(PROFILE_FIELDS.fieldNames.country),
      value: profile.country,
      fieldName: 'country',
      limit: LENGTH_VALUES.COUNTRY.MAX,
    },
    {
      id: IDS.FORM_FIELDS.HOME_PHONE,
      name: formatMessage(PROFILE_FIELDS.fieldNames.homePhone),
      value: getPhoneWithoutUSCode(profile.homePhone),
      limit: LENGTH_VALUES.HOME_PHONE.MAX,
      type: 'number',
      fieldName: 'homePhone',
      validationRules: {
        [RULES.PHONE]: {
          message: 'profile.phone.format',
        },
        [RULES.MIN_LENGTH]: {
          message: 'profile.phoneHome.format',
          length: LENGTH_VALUES.PHONE_NUMBER.MIN,
        },
      },
    },
  ];
}



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/HomeAddress/getFieldsHomeAddressSection.js